// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"116":"Play","987":"Lobby"}[chunkId] || chunkId) + "." + {"116":"7f529849","787":"bc6b80b8","987":"b17ab621"}[chunkId] + ".chunk.js";
};